import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { type Brand } from '~/hooks/useSurveyQuery'
import { type Group, type NineSegment } from '~/utils'

export {
  type DisplayColumnKey,
  type DisplayRowId,
  type GroupsDiff,
  type IndividualSortColumnKey,
  type MatrixSortColumnKey,
  type QuestionsDiffsMap,
  type ScrollHash,
  type SequentialSortColumnKey,
} from '~/components/features/GroupCountsFigures'

export const pathKey = 'customizedAnalysis' satisfies PathKey

export type GroupInfo = {
  brandNumber: Brand['number']
  nineSegment: NineSegment
  group: Group
}
